import { render, staticRenderFns } from "./GuestsOrders.vue?vue&type=template&id=76c99c00"
import script from "./GuestsOrders.vue?vue&type=script&lang=js"
export * from "./GuestsOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports